export default __webpack_public_path__ + "images/FR.1577adf.png";